<template>
  <div class="mb-3">
    <VSelect
      v-model="status"
      :items="statusSelectItems"
      item-text="name"
      item-value="status"
      outlined
      dense
      hide-details
      class="body-2"
      :disabled="readonly"
      @input="onUpdate"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import {
  computed, ref, toRefs, watch,
} from '@vue/composition-api';
import { candidateStatus } from '@/enums';

export default {
  name: 'AppCandidateStatusesSelect',
  components: { },
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const { useActions, useState } = createNamespacedHelpers('kanban');
    const { fetch } = useActions(['fetch']);
    const { stages } = useState(['stages']);
    const { value } = toRefs(props);

    if (!stages.value) {
      fetch();
    }

    const status = ref(value.value);

    watch(value, () => {
      status.value = value.value;
    });

    function canStatusShow(s) {
      if (status.value !== candidateStatus.IMPORTED
        && s.status === candidateStatus.IMPORTED) {
        return false;
      }

      if (status.value === candidateStatus.IMPORTED
        && s.status === candidateStatus.INVITED) {
        return true;
      }
      return !(status.value !== candidateStatus.INVITED
        && s.status === candidateStatus.INVITED);
    }

    const statusSelectItems = computed(() => {
      return stages.value?.filter(canStatusShow);
    });

    return {
      status,
      statusSelectItems,
      candidateStatus,
      onUpdate(value) {
        emit('input', value);
      },
    };
  },
};
</script>

<i18n locale="en" lang="yaml">
  imported: Imported
  invited: Invited
  interviewed: Passed the interview
  inoffice_interview: Invited for an in-office interview
  job_offer: Job offer
  hired: Hired
  declined: Declined
</i18n>

<i18n locale="ru" lang="yaml">
  imported: Импортирован
  invited: Приглашение отправлено
  interviewed: Прошел интервью
  inoffice_interview: Приглашен на очное интервью
  job_offer: Предложение о работе
  hired: Выход на работу
  declined: Отказ
</i18n>
